import React from 'react';
import styled, { css } from 'styled-components';
import { Shapeable, Video } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { CellLabel, EntityCard, EntityCardDefaultProps, EntityCardProps, useLang, useModal, VideoImage, VideoPlayer } from '@shapeable/ui';
import { EntityCuratorFootMeta } from './entity-curator-foot-meta';
import { VERY_LIGHT_BROWN } from '../../theme';
const cls = classNames('video-curator-card');

// -------- Types -------->

// -------- Props -------->

export type VideoCuratorCardProps = EntityCardProps & { 
  entity?: Video;
};

export const VideoCuratorCardDefaultProps: Omit<VideoCuratorCardProps, 'entity'> = {
  ...EntityCardDefaultProps,
  descriptionMaxLines: 5,
  showDescription: true,
  showTypeHeader: false,
  showDescriptionDivider: false,
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const ImageStyles = breakpoints({
  base: css`
    min-width: 100px;
  `,
});

const VideoStyles = breakpoints({

});

const FootMetaStyles = breakpoints({
  base: css`
    
  `,
});

// -------- Components -------->

const My = {
  Container: styled(EntityCard)<ContainerProps>`${ContainerStyles}`,
    Image: styled(VideoImage)`${ImageStyles}`,
    Video: styled(VideoPlayer)`${VideoStyles}`,
    FootMeta: styled(EntityCuratorFootMeta)`${FootMetaStyles}`,
    
};

export const VideoCuratorCard: Shapeable.FC<VideoCuratorCardProps> = (props) => {
  const { className, entity, ...cardProps } = props;

  const modal = useModal();
  
  /* I had to make this entire card clickable to a modal for the moment to rush through for Villars Review */

  const buttonOnClick = (() => {
    modal.show(<My.Video playing url={entity.url} />, { color: '#000000', title: entity.name });
  });

  return (
    <My.Container 
      {...cardProps}
      entity={entity}
      showDescription={true}
      onClick={buttonOnClick}
      useLink={false}
      imageProps={{ showIcon: false }}
      showExternalLink={false}
      image={<My.Image entity={entity} />}
      showDescriptionDivider={false}
      className={cls.name(className)}
      colors={{ background: VERY_LIGHT_BROWN }}
    />
  )
};

VideoCuratorCard.defaultProps = VideoCuratorCardDefaultProps;
VideoCuratorCard.cls = cls;